import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import PortalVue from 'portal-vue'
import VueRouter from 'vue-router'
import router from './router'
import store from './store'
import i18n from './i18n'
import axios from 'axios'
import moment from 'moment'
import { GridPlugin } from '@syncfusion/ej2-vue-grids';
import { registerLicense } from '@syncfusion/ej2-base';
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'
import vClickOutside from 'v-click-outside'
import VueTippy from "vue-tippy";
import VueCompositionAPI from '@vue/composition-api'
import { SciChartSurface } from "scichart";
import { configureSciChartWasm, diagnoseSciChartWasm } from "./utils/scichartWasm";
// Dymki rollovera nie wychodzą poza lewą krawędź wykresu (poprawka SciChart 2.2).
import "./utils/sciChartRollover";
import { initTheme } from "./utils/theme";

Vue.prototype.moment = moment
Vue.prototype.$http = axios;
// TEST LOKALNY: API uruchomione na 127.0.0.1:5080 (port 5000 zajmuje na macOS ControlCenter/AirPlay).
// Przed powrotem na produkcje przywroc adres cloudapi.
Vue.prototype.$http.defaults.baseURL = 'https://cloudapi.biocontrol.pl/api/'
// Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:5080/api/'

// Pliki wasm/data SciChart muszą pochodzić z tej samej wersji co ten bundle.
// Ścieżka ze stemplem wersji jest generowana z libraryVersion tej samej paczki
// npm, z której build kopiuje wasm (build/scichart-wasm.js), więc po wystawieniu
// nowej wersji cache przeglądarki nie może podstawić starych plików.
configureSciChartWasm();
diagnoseSciChartWasm();

// Motyw jasny/ciemny: atrybut data-theme na <html> spięty ze store.
initTheme(store);

SciChartSurface.setRuntimeLicenseKey("9fnKobcZvtBNBF9jQZk3G5P+MrqSU5Qy0LVdrM1wYFsj8qYS3Tl0FC8jRn3oqMFYX4XOpxuvho28MP7RovThJlsDqxPAv8Cokf4ntMh/ntIM/eNY8pn1w/k/m/DQauzO4fn9y/VUPiDWc/2AzNuKZByCWz7ine9T/4Sk+rMMUgUvWSyE5But64BfiYdX+1YKebjAijSspdwI5B9Ny2KCtNaBA4x36/Nm2WU4gMtRieT2oEeRqkWB34rLGbFXJqswFmXLV/wLC+a0iDVohNonX8hBB8eh/RTo5slTz0U/nRenuNl5FD3atRpKxr+QtC7OYVlXpBPF7k1zt7W9WmW75obS44T8q4huJxBgcWzxzIdfZmgL9O+/ehL7FX9k5IFs7e7J6x4nfV7sSQo2zPi+YsG8rA+dQTAASxxMJbc3p8p/rkYnEHj5eCVmfnw47YV8FHtRM/YOH8H9W3ERbEFLnkc2NMwCuzqbfME4JzGcWDjizwI12Y/eO3yKa/qg1+iSctO6UyyANJ/dK7G/Uc+6dgzCef4TdlfKuqfVtENyIACHxBD4gcyA1mcEb+rDp6rcyC0Xyrk00EGarIKYcOLt9gE5+DwuOb6P3ZmrXYNeU8jplYlP7sz1wTuEBQwY1wmGs7wtmeOHd4gCEErz44hpWT4oE95O9k79xR2Z4S8C49WMAbjQWC0MZxJFxLMo1MEeplRYfkFUbP1WDnHwWGP8svH/3RBvwETvKO1Qmvw=");
registerLicense('ORg4AjUWIQA/Gnt2V1hhQlJMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5Ud0xjUXtXc31TRGhd');

const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

Vue.use(PortalVue)
Vue.use(BootstrapVue)
Vue.component('v-select', vSelect)
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(GridPlugin)
Vue.use(vClickOutside)
Vue.use(VueTippy);
Vue.use(VueCompositionAPI)

new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  render: h => h(App),
  created: function () {
    Vue.prototype.$http.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.response && err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest) {
          store.dispatch('logout')
        }
        throw err;
      });
    });
  }
}).$mount('#app')

axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  // Cancelled requests (AbortController) and network errors have no response - pass them through untouched.
  if (axios.isCancel(error) || !error.response) {
    return Promise.reject(error);
  }
  let errMsg = error.response.data.error;
  if (error.response.status == 401 && error.response.config && !error.response.config.__isRetryRequest) {
    store.dispatch('logout');
    router.push('/');
  }
  else if (error.response.status == 400) {
    console.error(errMsg)
  }
  return Promise.reject(error);
});

Array.prototype.repeat = function (what, L) {
  while (L) this[--L] = what;
  return this;
}

String.prototype.toDateTime = function () {
  let result = moment(this).format('YYYY-MM-DD HH:mm:ss');

  if (result == "Invalid date") {
    result = moment(this, 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');
  }

  return result;
}

Date.prototype.toAgoString = function () {
  var now = new Date()
  var t1 = this
  var seconds = parseInt((now.getTime() - t1.getTime()) / 1000);
  var result = ""
  if (seconds < 60) { //seconds ago
    result = seconds + "s " + i18n.t('ago')
  } else if (seconds < 3600) { //minutes ago
    var minutes = parseInt(seconds / 60, 10)
    var seconds = parseInt(seconds % 60, 10)
    result = `${minutes}min ${seconds}s ` + i18n.t('ago')
  } else if (seconds < 3600 * 24) { // hours
    var hours = parseInt(seconds / 3600, 10)
    var minutes = parseInt((seconds / 60) % 60, 10)
    result = `${hours}h ${minutes}min ` + i18n.t('ago')
  } else { //days
    var days = parseInt(seconds / (3600 * 24))
    result = `${days} ${i18n.t('days')} ${i18n.t('ago')}`
  }

  return result
}

Date.prototype.toAgoStringVer2 = function () {
  var now = new Date();
  var t1 = this;
  var seconds = parseInt((now.getTime() - t1.getTime()) / 1000);
  var result = "";

  if (seconds >= 3600 * 24 * 365 * 100) { // more than 100 years
    result = i18n.t('Never');
  } else if (seconds >= 3600 * 24 * 365) { // more than a year
    var years = parseInt(seconds / (3600 * 24 * 365), 10);
    result = `${years} ${i18n.t('years')} ${i18n.t('ago')}`;
  } else if (seconds < 3600) { // less than an hour
    var minutes = parseInt(seconds / 60, 10);
    var remainingSeconds = parseInt(seconds % 60, 10);
    result = `${minutes}min ${remainingSeconds}s ${i18n.t('ago')}`;
  } else if (seconds < 3600 * 24) { // less than a day
    var hours = parseInt(seconds / 3600, 10);
    var minutes = parseInt((seconds / 60) % 60, 10);
    result = `${hours}h ${minutes}min ${i18n.t('ago')}`;
  } else if (seconds < 3600 * 48) { // less than 2 days
    var days = parseInt(seconds / (3600 * 24), 10);
    var hours = parseInt((seconds % (3600 * 24)) / 3600, 10);
    result = `${days} ${i18n.t('day')} ${hours}h ${i18n.t('ago')}`;
  } else { // 2 days or more
    var days = parseInt(seconds / (3600 * 24), 10);
    result = `${days} ${i18n.t('days')} ${i18n.t('ago')}`;
  }

  return result;
};

String.prototype.toDate = function () {
  return moment(this).format('DD-MM-YYYY');
}

Number.prototype.toAgoString = function () {
  if (this == 0) {
    return '-'
  }
  else if (this < 60) {
    return this + 's'
  }

  var noSeconds = this / 60
  return parseInt(noSeconds / 60, 10) + "h " + parseInt(noSeconds % 60, 10) + "min"
}


Number.prototype.formatBytes = function (decimals = 2) {
  if (!+this) return '0 Bytes'

  const k = 1024
  const dm = decimals < 0 ? 0 : decimals
  const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

  const i = Math.floor(Math.log(this) / Math.log(k))

  return `${parseFloat((this / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
}


// WEBPACK FOOTER //
// ./src/main.js